import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(auth)/login/page.tsx")